import { useSettings } from "../settings/useSettings";
import { _evaluatePath } from "./getCurrentPath";
import { useStartPage } from "./useStartPage";
import { CVPSearchParams, queryStringStore } from "./wsQueryStringStore";
import { routerStore } from "./WSRouter";

/**
 * The path the app internally uses, not necessarily the same as the browser path.
 */
export function useCurrentPath(): string {
  const iframe_startPage = useStartPage();
  const settings = useSettings();
  const cvpage = queryStringStore.qs[CVPSearchParams.cvpage];
  const cvpEmbedType = window.cvpEmbedType;
  let pathname = routerStore.location.pathname;

  return _evaluatePath(
    settings,
    !!window.cvpSandboxType,
    routerStore.hostUrl,
    cvpEmbedType,
    iframe_startPage,
    window.iframe_preventNavigationTakeover,
    cvpage,
    pathname
  );
}
